<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-at" /></div>
        <input
          type="email"
          name="email"
          ref="loginemail"
          v-model="form.email"
          class="form-control"
          :class="{ 'form-control-sm': position == 'aside', 'is-invalid': errors.form.email.length }"
          placeholder="Адрес эл. почты" />
        <div v-if="errors.form.email.length" class="invalid-feedback">{{ errors.form.email }}</div>
      </div>
    </div>

    <div data-error class="alert alert-warning mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="mt-2 mb-1 text-end">
      <button
        type="submit"
        class="btn btn-primary"
        :class="{ 'btn-sm': position == 'aside' }"
        :disabled="form.email.length == 0 || errors.form.email.length || isLoading"
        title="Получить код для входа">
        <font-awesome-icon icon="fa-solid fa-key" /> Получить код
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAt, faKey } from '@fortawesome/free-solid-svg-icons';
library.add(faAt, faKey);

import { checkEmail } from '@/composable/functions';

export default {
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        email: '',
      },
      errors: {
        form: {
          email: '',
          common: '',
        },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
    // предзаполнить
    phone: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    // тут не используется
    until: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.email.length == 0) {
        this.errors.form.email = 'Нужно ввести адрес эл. почты.';
        return false;
      }

      this.isLoading = true;

      axios
        .post(`/backend/login/request/email`, this.form)
        .then((res) => {
          // ??? надо?
          if (res.data.message !== '') {
            this.$bs5utils.Snack.show('info', res.data.message, this.$store.getters.delay.info);
          }

          if (res.data.status === 'ok') {
            this.$emit('go-step', {
              step: 1,
              uid: res.data.uid,
              until: res.data.until,
              email: this.form.email,
            });
          }

          if (res.data.status === 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    'form.email'(newVal) {
      this.errors.form.email = checkEmail(newVal);
    },
  },
  mounted() {
    // если есть email, то сразу его подставить
    this.form.email = this.email;

    this.$refs.loginemail.focus();
  },
};
</script>
